import '.a0{position:relative;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.a1{height:100%;}.ssr-plugin'
import '.ci{overflow-y:scroll;}.ssr-plugin'
import '.cs{opacity:0;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.c6{z-index:2;}.ssr-plugin'
import '.b4{appearance:none;}.ssr-plugin'
import '.o{background:transparent;}.ssr-plugin'
import '.p{border:none;}.ssr-plugin'
import '.e3{padding:4px;}.ssr-plugin'
import '.e4{transition:transform 100ms cubic-bezier(0.2,0,0,1);}.ssr-plugin'
import '.e5{padding:0 20px;}.ssr-plugin'
import '.dv{font-size:13px;}.ssr-plugin'
import '.dw{font-family:Geist Mono;}.ssr-plugin'
import '.dx{line-height:20px;}.ssr-plugin'
import '.dy{counter-increment:line;}.ssr-plugin'
import { Highlight, themes } from 'prism-react-renderer'
import { styled } from 'inlines'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Icon } from '../Icon/index.js'
import { Tooltip } from '../Tooltip/index.js'
import { useTheme } from '../../hooks/useTheme.js'
import { useToast } from '../Toast/index.js'

type CodeBlockProps = {
  code: string
  language: 'js' | 'jsx' | 'ts' | 'tsx' | 'bash'
  fileName?: string
  lineNumbers?: boolean
  highlightedLines?: number[]
  border?: boolean
  copy?: boolean
}

function CodeBlock({
  fileName,
  language,
  highlightedLines,
  code,
  lineNumbers = true,
  border = true,
  copy = true,
}: CodeBlockProps) {
  const { theme } = useTheme()
  const toast = useToast()

  return (
    <styled.div className="a0 h a1 ci"
      data-header={fileName ? 'true' : undefined}
      style={{
        ...(border && {
          border: `1px solid ${colors.neutral20Adjusted}`,
          borderRadius: radius[12],
          overflow: 'hidden',
        }),
        '&[data-header] .copyButton, &:hover .copyButton': {
          opacity: '1 !important',
        },
      }}
    >
      {copy && (
        <styled.div className="copyButton cs a a2 c6"
          style={{
            top: fileName ? 12 : 20,
            right: fileName ? 16 : 20,
            '&:focus-within': {
              opacity: 1,
            },
          }}
        >
          <Tooltip description="Copy code">
            <styled.button className="b4 o p a e3 e4"
              style={{
                color: colors.neutral60,
                borderRadius: radius[8],
                margin: -4,
                '&:hover': {
                  background: colors.neutral10Adjusted,
                  color: colors.neutral100,
                },
                '&:active': {
                  transform: 'scale(0.945)',
                },
                '&:focus-visible': {
                  background: colors.neutral10Adjusted,
                  color: colors.neutral100,
                  outline: `${colors.neutral20} solid 4px`,
                },
              }}
              onClick={() => {
                navigator.clipboard.writeText(code)
                toast('Code copied')
              }}
            >
              <Icon variant="copy" />
            </styled.button>
          </Tooltip>
        </styled.div>
      )}
      {fileName && (
        <div
          style={{
            height: 48,
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            boxShadow: `0 1px 0 ${colors.neutral20Adjusted}`,
            background: colors.neutral5,
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontFamily: 'Geist Mono',
              color: colors.neutral60,
            }}
          >
            {fileName}
          </div>
        </div>
      )}
      <Highlight
        theme={theme === 'light' ? themes.oneLight : themes.oneDark}
        code={code}
        language={language}
      >
        {({ tokens, getTokenProps }) => (
          <pre
            style={{
              padding: '20px 0',
              overflow: 'hidden',
              whiteSpace: 'pre-wrap',
            }}
          >
            {tokens.map((line, i) => (
              <styled.div className="e5 a0 dv dw dx dy"
                key={i}
                style={{
                  ...(lineNumbers && {
                    '&:before': {
                      display: 'inline-block',
                      minWidth: 16,
                      textAlign: 'right',
                      marginRight: 20,
                      content: 'counter(line)',
                      color: colors.neutral60,
                    },
                  }),
                  ...(highlightedLines?.includes(i) && {
                    background: colors.neutral5,
                    '&:after': {
                      content: '""',
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: 2,
                      background: colors.neutral10,
                    },
                  }),
                }}
              >
                {line.map((token, ii) => (
                  <span key={ii} {...getTokenProps({ token })} />
                ))}
              </styled.div>
            ))}
          </pre>
        )}
      </Highlight>
    </styled.div>
  )
}

export { CodeBlock }
export type { CodeBlockProps }
